export const USER_ATTRIBUTES = {
    FIRST_NAME: 'fqqM9M2HOTS',
    SECOND_NAME: 'dlG2zF6SdRy',
    PHONE: 'aOfR1b3W2gv',
    DOB: 'Ndsp9fQExRc',
    EMAIL: 'zjwngtjgvLB',
 };

// Staff TEI Attributes
export const STAFF_ATTRIBUTES = {
  USERNAME: 'g3RRIfDiQra'
};

export const STAFF_ROLES_ID = [
  { id: 'vdVjNaqxblC', label: 'Senior Staff' },
  { id: 'gtMJNK0QVL7', label: 'Top Staff' },
  { id: 'R3lFolCMdoi', label: 'Admin' },
  { id: 'adeqQmxfCLF', label: 'Head of Department' },
  { id: 'nLSSLch316I', label: 'Chief Executive Officer' },
];

export const ROLE_LEVEL_MAP = {
  'nLSSLch316I': 5,  // CEO
  'adeqQmxfCLF': 6,  // Head of Department
  'gtMJNK0QVL7': 7,  // Top Staff
  'vdVjNaqxblC': 8,  // Senior Staff
};

// Add to your constants file
export const ROLE_USERGROUP_MAP = {
  'nLSSLch316I': 'HX3KpMqekvQ', // CEO -> CEO Group
  'adeqQmxfCLF': 'DxVo5hprMUT', // HOD -> HOD Group  
  'gtMJNK0QVL7': 'DvljV6tAg4V', // Top Staff -> Top Staff Group
  'vdVjNaqxblC': 'NlVOvQKmhqr', // Senior Staff -> Senior Staff Group
};

export const POSITION_ATTRIBUTES = {
  POSITION_ID: 'VwhhrV1ODQK',
  POSITION_TITLE: 'NWe61Sa41CS', 
  DEPARTMENT: 'YsGPrrVLAuM',
  JOB_GRADE: 'gp4AnggIDi8',
  POSITION_STATUS: 'Ch7TyL91heU',
  CURRENT_INCUMBENT: 'V66IFsw5kq6',
  PREVIOUS_INCUMBENTS: 'YFmL9BJVJ44',
  REPORTING_TO: 'SjP47qi3JeB'
};


export const POSITION_HISTORY_PROGRAM = 'bzvlzdKhtFb';
export const POSITION_TEI_TYPE = 'UGGo0Ebjl0E';
export const POSITION_HISTORY_STAGE = 'PFjdgj8SUNd';
 // constants.js

export const STAFF_TEI_TYPE = 'OaAbpIs1cV7';

// Main Performance Programs
export const PERFORMANCE_MANAGEMENT_PROGRAM = 'yiT00XKrrHP'; // Performance Management Monitoring Program
export const LEADERSHIP_MANAGEMENT_PROGRAM = 'RSANdetbnWC';   // Leadership and Management Program
export const COMPANY_GOALS_PROGRAM = 'NkReudUAW4F';          // Company Goals Management Program

   // Position Occupancy History Stage


// Position History Data Elements (for staff assignment tracking)
export const POSITION_DATA_ELEMENTS = {
  ACTION_TYPE: 'AXodktztnJi',        // Position Action Type
  POSITION_ID: 'SlgO60cMK3F',        // Position ID (in events)
  STAFF_MEMBER: 'OHKFI8GuxPs',       // Incumbent ID
  START_DATE: 'MZHGfRa0Oqa',         // Position Start Date
  END_DATE: 'YsFQl51qmvd',           // Position End Date
  EFFECTIVE_DATE: 'DoAGWqub8Cz',     // Position Effective Date
  NOTES: 'xoNoPDw9XPM'               // Position Notes
};


// Performance Management Program Stages
export const PERFORMANCE_STAGES = {
  OBJECTIVES: 'VIBtpvkpHFR',         // Objectives Stage
  TASKS: 'Nv9nYNcBTdM',              // Tasks Stage
  KRA: 'BJb3qTgbcTF',                // KRA Stage
  KPI: 'ivyCLjNLFrd',                // KPI Stage
  COMPANY_GOALS: 'QPDYMPIwsFQ'       // Company Goals Stage
};

// Leadership Management Program Stages
export const LEADERSHIP_STAGES = {
  MID_YEAR_REVIEW: 'mJ3mC8f2eMv',    // Mid-Year Review
  YEAR_END_REVIEW: 'TiLy9LFPaNo',    // Year-End Review
  WEIGHT_TARGETS: 'zY4mj9a30tk'      // Weight Targets
};


// Positions Program IDs
export const POSITIONS_PROGRAMS = {
  PERFORMANCE: 'yiT00XKrrHP', // Performance Management Monitoring Program
  LEADERSHIP: 'RSANdetbnWC',   // Leadership and Management Program
  POSITION_HISTORY_PROGRAM: 'bzvlzdKhtFb'
};

// Update TEMPLATE_STRUCTURE
export const TEMPLATE_STRUCTURE = {
  requiredFields: ['Position Title', 'Department', 'Job Grade', 'Status'],
  optionalFields: ['Reporting To Position Title', 'Notes'],
  columnMappings: {
    'Position Title': POSITION_ATTRIBUTES.POSITION_TITLE,
    'Department': POSITION_ATTRIBUTES.DEPARTMENT,
    'Job Grade': POSITION_ATTRIBUTES.JOB_GRADE,
    'Status': POSITION_ATTRIBUTES.POSITION_STATUS,
    'Reporting To Position Title': POSITION_ATTRIBUTES.REPORTING_TO, // This will store TEI ID
    }
};




